import {useEffect} from 'react';
import qs from 'qs';
import {omit} from 'lodash';
import {addToast} from '@albert-io/atomic';
import {browserHistory} from 'lib/router';

const LTI_NOTICE_PARAM = 'lti_notice';

const NOTICE_TOASTS = {
  email_claimed: {
    title: 'Email not updated',
    message: 'Email could not be updated because it is already claimed by another user.',
    color: 'warning'
  }
} as const;

let capturedNotice: string | undefined;

function parseSearch() {
  return qs.parse(window.location.search.replace(/^\?/, ''));
}

/**
 * Remembers the `lti_notice` query parameter of the URL the app booted on. Call it before the
 * router is created: route-level redirects (for example `/classes` → `/home` for students) and
 * the signed-in redirect away from `/` replace the URL, query included, before any component
 * renders.
 */
export function captureLtiNotice() {
  const notice = parseSearch()[LTI_NOTICE_PARAM];
  capturedNotice = typeof notice === 'string' ? notice : undefined;
}

function removeNoticeFromUrl() {
  const params = parseSearch();
  if (!(LTI_NOTICE_PARAM in params)) {
    return;
  }
  const remaining = qs.stringify(omit(params, LTI_NOTICE_PARAM));
  const {pathname, hash} = window.location;
  browserHistory.replace({pathname, search: remaining ? `?${remaining}` : '', hash});
}

/**
 * Shows the toast an LTI launch asked for through `lti_notice` in the query string of the page it
 * redirected to, then drops the parameter from the URL so a refresh does not repeat it.
 */
export default function LtiNoticeToast() {
  useEffect(() => {
    const notice = capturedNotice;
    capturedNotice = undefined;
    if (notice === undefined) {
      return;
    }
    if (notice in NOTICE_TOASTS) {
      addToast(NOTICE_TOASTS[notice as keyof typeof NOTICE_TOASTS]);
    }
    removeNoticeFromUrl();
  }, []);

  return null;
}
